import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

export const login = data =>
  request(`${apiUrl}/login`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });

export const verifyAuth = (token, resourceParams = null) => {
  let url = `${apiUrl}/auth`;

  if (resourceParams) {
    const queryParams = new URLSearchParams();
    Object.entries(resourceParams).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });
    const queryString = queryParams.toString();
    if (queryString) {
      url = `${url}?${queryString}`;
    }
  }

  return request(url, token);
};

export const getAdminSeller = (sellerId, token) =>
  request(`${apiUrl}/admin/sellers/${sellerId}`, token);

export const getAuthContext = async token => request(`${apiUrl}/auth/context`, token);

export const switchAuthStore = async (token, { sellerId } = {}) =>
  request(`${apiUrl}/auth/switch-store`, token, {
    body: JSON.stringify({ sellerId }),
    method: 'POST',
  });

export const createAuthStore = async (token, { displayName } = {}) => {
  return request(`${apiUrl}/auth/create-store`, token, {
    method: 'POST',
    ...(displayName && { body: JSON.stringify({ displayName }) }),
  });
};
